import { createSelector } from 'reselect';

import { draftModuleSelector } from '../utils';
import { getDraftPreflight } from './utils';

export const preflightStateSelector = createSelector(draftModuleSelector, getDraftPreflight);
